import desk from '@/api/desk'
import category from '@/api/categroy'
import merchantDevice from '@/api/merchant-device'
import order from '@/api/order'
import departmentProduct from './department-product'
import site from './site'
import staff from './staff'
import customOfflinePayMethods from './custom-offline-pay-methods'
import givingCards from './giving-cards'
import opRecords from './op-records'
import handWord from './hand-word'
import waitMakeTransfer from './wait-make-transfer'
import deskOpens from './desk-opens'
import customerPrepaymentPayRecord from './customer-prepayment-pay-record'
import customerPrepaymentQrCodes from './customer-prepayment-qr-codes'
import wineConfiscations from './wine-confiscations'
export default {
  desk,
  category,
  merchantDevice,
  order,
  departmentProduct,
  site,
  staff,
  customOfflinePayMethods,
  givingCards,
  opRecords,
  handWord,
  waitMakeTransfer,
  deskOpens,
  customerPrepaymentPayRecord,
  customerPrepaymentQrCodes,
  wineConfiscations
}
